import { render, staticRenderFns } from "./quill.vue?vue&type=template&id=96f93cc0&scoped=true"
import script from "./quill.vue?vue&type=script&lang=js"
export * from "./quill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f93cc0",
  null
  
)

export default component.exports